
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import ManifestModule from "@/store/modules/barcodeSystem/manifest";
import { formatDateWithTime, formatDate } from "@/utils";
import { AvailableBarcodeOrderListItem } from "@/models/api/barcodeSystem/manifests/get";

const manifestModuleState = getModule(ManifestModule);

@Component
export default class AvailableOrderTable extends Vue {
  @Prop({ default: false })
  loading: boolean;
  hideManifestedOrders: boolean = true;
  filterString: string = '';

  get availableOrders(): Array<AvailableBarcodeOrderListItem> {
    if(manifestModuleState.availableOrders)
      return manifestModuleState.availableOrders.filter(x => !manifestModuleState.currentManifestDetails.some(y => y.orderId == x.id) && (!this.hideManifestedOrders || (!x.activeManifest || x.activeManifest.id == this.currentManifestId)));
    return [];
  }

  get currentManifestId() : number {
    return manifestModuleState.currentManifest && manifestModuleState.currentManifest.id ? manifestModuleState.currentManifest.id : 0;
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDate(val)
  {
    return formatDate(val);
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }

  onDoubleClicked(order: AvailableBarcodeOrderListItem) {
    this.addOrder(order)
  }

  onRowClick(data) { 
    
  }

  unselectAll() {
  }

  addOrder(order: AvailableBarcodeOrderListItem) {
    if(!order.activeManifest || order.activeManifest.id == this.currentManifestId)
      manifestModuleState.addManifestDetail(order);
  }
}
